
    import './styles.scoped.css';
    export default {
  "key-value-pairs": "awsui_key-value-pairs_1y9fy_19juz_9",
  "group-title": "awsui_group-title_1y9fy_19juz_41",
  "group-list": "awsui_group-list_1y9fy_19juz_45",
  "group-list-item": "awsui_group-list-item_1y9fy_19juz_55",
  "term": "awsui_term_1y9fy_19juz_59",
  "key-label": "awsui_key-label_1y9fy_19juz_67",
  "detail": "awsui_detail_1y9fy_19juz_76",
  "info": "awsui_info_1y9fy_19juz_112"
};
  